import { forwardRef } from 'react';

import {
  useMonkeysBaseAppearance,
  useMonkeysComponentAttributes,
} from '../../provider/context';
import {
  resolveBaseAppearance,
  resolveBaseLayoutLength,
} from './theme';
import type { BaseContainerProps } from './types';
import { cn } from './utils';

export const BaseContainer = forwardRef<HTMLDivElement, BaseContainerProps>(
  function BaseContainer(
    {
      children,
      maxWidth = '80rem',
      padding = '1rem',
      appearance,
      className,
      classNames,
      style,
      ...containerProps
    },
    ref,
  ) {
    const resolvedAppearance = useMonkeysBaseAppearance(appearance);
    const componentAttributes = useMonkeysComponentAttributes();
    const theme = resolveBaseAppearance(resolvedAppearance);
    const resolvedMaxWidth = resolveBaseLayoutLength(
      'BaseContainer',
      'maxWidth',
      maxWidth,
    );
    const resolvedPadding = resolveBaseLayoutLength(
      'BaseContainer',
      'padding',
      padding,
    );

    return (
      <div
        {...componentAttributes}
        {...containerProps}
        ref={ref}
        data-monkeys-component="container"
        data-slot="root"
        className={cn(theme.slots.containerRoot, classNames?.root, className)}
        style={{
          ...theme.styles.container,
          maxWidth: resolvedMaxWidth,
          paddingInline: resolvedPadding,
          ...style,
        }}
      >
        {children}
      </div>
    );
  },
);
